import { render, staticRenderFns } from "./CreateIssue.vue?vue&type=template&id=d567bbfa&scoped=true&"
import script from "./CreateIssue.vue?vue&type=script&lang=js&"
export * from "./CreateIssue.vue?vue&type=script&lang=js&"
import style0 from "./CreateIssue.vue?vue&type=style&index=0&id=d567bbfa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d567bbfa",
  null
  
)

export default component.exports